<template>
  <div class="home">
    <img alt="Vue logo" src="@/assets/logo.png">
    <el-tag type="success">element</el-tag>
  </div>
</template>

<script>
export default {
  components: {},
  mounted() {
    const ua = this.$utils.ua();
    console.log(ua);
  },
};
</script>
